export const ROLE = '/role/' as const
export const ROLE_ALL = `${ROLE}all` as const
